// extracted by mini-css-extract-plugin
module.exports = {"container":"_2jqi8GNFCmmxpyRMs_U8if","groupsList":"_3jn5Dis0V51BrzHANJa4lM"};